import '../styling/NewCreateClientForm.css'
import userimage from '../resources/user.png'
import homeimage from '../resources/home.png'
import {Link} from 'react-router-dom'
import {useState} from 'react'
import {useClientsContext} from '../hooks/useClientsContext'
import { useAuthContext } from '../hooks/useAuthContext';
import API_BASE_URL from '../config.js';


const NewCreateClientForm = ({updateError, updateSuccess}) => {

    
    const {dispatch} = useClientsContext()

    const[clientFirst, setFirst] = useState('')
    const[clientLast, setLast] = useState('')
    const[clientCompany,setCompany] = useState('')
    const[clientPhone, setPhone] = useState('')
    const[clientEmail, setEmail] = useState('')
    const[clientStreet1, setStreet1] = useState('')
    const[clientStreet2, setStreet2] = useState('')
    const[clientCity, setCity] = useState('')
    const[clientState, setState] = useState('')
    const[clientZip, setZip] = useState('')
    const[clientCountry, setCountry] = useState('')
    const {user} = useAuthContext();
    const[emptyFields, setEmptyFields] = useState([])

    const handleSubmit = async (e) => {
        e.preventDefault()

        if(!user){
            updateError("You must be logged in!")
            return
        }

        
        if(!clientFirst && !clientLast){
            updateError("Client First Name and Client Last Name required!")
            return
        }
        else if(!clientFirst){
            updateError("Client First Name required!")
            return
        }
        else if(!clientLast){
            updateError("Client Last Name required!")
            return
        }

        const client = {clientFirst, clientLast, clientCompany, clientPhone, clientEmail, clientStreet1, clientStreet2, clientCity, clientState, clientZip, clientCountry}

        const response = await fetch(`${API_BASE_URL}/api/client`, {
            method: "POST",
            body: JSON.stringify(client),
            headers:{
                "Content-Type": 'application/json',
                "Authorization": `Bearer ${user.token}`
            }
        })

        const json = await response.json();

        if (!response.ok){
            updateError(json.error)
            setEmptyFields(json.emptyFields)
        }

        if(response.ok){
            setFirst('')
            setLast('')
            setCompany('')
            setPhone('')
            setEmail('')
            setStreet1('')
            setStreet2('')
            setCity('')
            setState('')
            setZip('')
            setCountry('')
            updateError("")
            setEmptyFields([])
            console.log("New workout added", json)
            dispatch({type: "CREATE_CLIENT", payload: json})
            updateSuccess("Client added successfully!")
        }



    }


    return ( 
        <div className="newcreateclientformcontainer">
            <form onSubmit={handleSubmit} style={{textDecoration: 'none'}}>
            <div className="newformleft">
                <div className="newclientitle">
                <div className="newformleftcircle">
                <img src={userimage} alt="" />
                </div>
                <h1 className="text-3xl font-bold ml-4">Client Details</h1> 
                </div>
                <div className="newformnames">
                <input type="text" placeholder="First Name" className="input input-bordered input-info w-full max-w-m" value={clientFirst} onChange={(e) => setFirst(e.target.value)}/>
                <input type="text" placeholder="Last Name" className="input input-bordered input-info w-full max-w-m" value={clientLast} onChange={(e) => setLast(e.target.value)}/>
                </div>
                <input type="text" placeholder="Company Name" className="input input-bordered input-info w-full max-m" value={clientCompany} onChange={(e) => setCompany(e.target.value)}/>
                <h1 className='text-1xl font-bold' id="nfcd">Contact Details</h1>
                <input type="phone" placeholder="Phone Number" className="input input-bordered input-info w-full max-m" value={clientPhone} onChange={(e) => setPhone(e.target.value)}/>
                <input type="email" placeholder="Email" className="input input-bordered input-info w-full max-m" value={clientEmail} onChange={(e) => setEmail(e.target.value)}/>
                <button className="btn btn-outline btn-error" type="button">
                <Link to="/quotes" style={{textDecoration: 'none'}}>Cancel
                </Link>
                </button>
            </div>
            <div className="newformright">
                <div className="newclientproperty">
                <div className="newformleftcircle">
                <img src={homeimage} alt="" />
                </div>
                <h1 className="text-3xl font-bold ml-4">Property Details</h1> 
                </div>
                <input type="text" placeholder="Street1" className="input input-bordered input-info w-full max-m" value={clientStreet1} onChange={(e) => setStreet1(e.target.value)}/>
                <input type="text" placeholder="Street2" className="input input-bordered input-info w-full max-m" value={clientStreet2} onChange={(e) => setStreet2(e.target.value)}/>
                <h1 className='text-1xl font-bold' id="nfcd">Address Details</h1>
                <div className="newformnames">
                <input type="text" placeholder="City" className="input input-bordered input-info w-full max-w-m"  value={clientCity} onChange={(e) => setCity(e.target.value)}/>
                <input type="text" placeholder="State" className="input input-bordered input-info w-full max-w-m" value={clientState} onChange={(e) => setState(e.target.value)}/>
                </div>
                <div className="newformnames">
                <input type="text" placeholder="Zip Code" className="input input-bordered input-info w-full max-w-m" value={clientZip} onChange={(e) => setZip(e.target.value)}/>
                <input type="text" placeholder="Country" className="input input-bordered input-info w-full max-w-m" value={clientCountry} onChange={(e) => setCountry(e.target.value)}/>
                </div>
                <button className="btn btn-outline btn-success" type="submit">Save Client</button>
            </div>
            </form>
        </div>
     );
}
 
export default NewCreateClientForm;